import { useMutation, useQueryClient } from '@tanstack/react-query';
import i18next from 'i18next';
import { useServices, useStores } from 'index';

type Callbacks = {
  onSuccess?: () => Promise<void> | void;
};

export const useRemoveStudents = (organizationId: string, callbacks?: Callbacks) => {
  const studentsService = useServices().studentsService;
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: (studentIds: string[]) => studentsService.removeStudents(organizationId, studentIds),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['organizationStudents', organizationId] }),
        queryClient.invalidateQueries({ queryKey: ['organizationNumberStudents', organizationId] }),
      ]);
      notificationsStore.addToast('success', i18next.t('StudentsRemovedSuccessfully', { ns: 'studentsPage' }), 'success');
      await callbacks?.onSuccess?.();
    },
    onError: () => notificationsStore.addToast('error', i18next.t('RemoveStudentsError', { ns: 'studentsPage' }), 'error')
  });
};
